import React, { useEffect, useState } from 'react';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { Add, Assignment, PictureAsPdf, Restore, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { Box, Tooltip, Checkbox } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { wsFindBy, wsUrl } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ButtonDelete from 'hooks/ButtonDelete';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import Badge from 'components/Badge/Badge';
import { wsUpdate } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { ConstantPermissions } from 'contexts/useConstant';
import ModalGuia from './Modal/ModalGuia';
import ModalUpdate from './Modal/ModalUpdate';
import { wsGetPdfPromise } from 'services/WService';
import { Toasty, useToasty } from "hooks/Toasty";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { wsRemove } from 'services/WService';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';

const useStyles = makeStyles({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 260 },
  { Header: 'Fec. Cont.', accessor: 'TaxDate', width: 100 },
  { Header: 'Fec. Doc.', accessor: 'DocDate', width: 100 },
  { Header: 'Monto', accessor: 'DetailAmount', width: 120 },
  { Header: 'Referencia', accessor: 'Ref2', width: 120 },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Cuenta', accessor: 'WhsAcctCode', width: 100 },
  { Header: 'Título', accessor: 'JrnlMemo' },
  { Header: 'Estado', accessor: 'state_migrate', width: 110 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Validado por', accessor: 'validated_user_name' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Comentario', accessor: 'Comments' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const columnsMovementInventory = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 260 },
  { Header: 'Proveedores', accessor: 'providers', Cell: ({ value }) => value ? (value.length > 100 ? `${value.substring(0, 100)}...` : value) : '' },
  { Header: 'Marcas', accessor: 'marks', Cell: ({ value }) => value ? (value.length > 40 ? `${value.substring(0, 40)}...` : value) : '' },
  { Header: 'Fec. Cont.', accessor: 'TaxDate', width: 100 },
  { Header: 'Fec. Doc.', accessor: 'DocDate', width: 100 },
  { Header: 'Monto', accessor: 'DetailAmount', width: 120 },
  { Header: 'Referencia', accessor: 'Ref2', width: 120 },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Cuenta', accessor: 'WhsAcctCode', width: 100 },
  { Header: 'Título', accessor: 'JrnlMemo' },
  { Header: 'Estado', accessor: 'state_migrate', width: 110 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Validado por', accessor: 'validated_user_name' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Comentario', accessor: 'Comments' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const transferColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 300 },
  { Header: 'ID', accessor: 'id', width: 80 },
  { Header: 'Fec. Cont.', accessor: 'TaxDate', width: 100 },
  { Header: 'Fec. Doc.', accessor: 'DocDate', width: 100 },
  { Header: 'Monto', accessor: 'DetailAmount', width: 120 },
  { Header: 'Guía Elec.', accessor: 'guide', width: 150 },
  { Header: 'Guía Tran.', accessor: 'guideTransfer', width: 150 },
  // { Header: 'Referencia', accessor: 'Ref2', width: 120 }, // NO EXISTE EL CAMPO REF2 EN LA TABLA DE TRANSFERENCIA
  { Header: 'Del almacén', accessor: 'FillerWhsName' },
  { Header: 'Al almacén', accessor: 'ToWhsName' },
  { Header: 'Cuenta', accessor: 'WhsAcctCode', width: 100 },
  { Header: 'Título', accessor: 'JrnlMemo' },
  { Header: 'Estado', accessor: 'state_migrate', width: 110 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Validado por', accessor: 'validated_user_name' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Comentario', accessor: 'Comments' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function KardexSharedFile(props) {
  const classes = useStyles();

  const { title, entity, type, excelName, permissions } = props;
  const [notify, showNotify] = useToasty();

  const [kardexs, setKardexs] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [alert, setAlert] = useState(null);
  const [openPDF, setOpenPDF] = useState(false);
  const [urlPDF, setURLPDF] = useState('');
  const [processing, setProcessing] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [checkeds, setCheckeds] = useState([]);
  const [openModalGuia, setOpenModalGuia] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const allHaveGuia = checkeds.every(item => item.guia_transfer_view?.id_guia);
  const noneHaveGuia = checkeds.every(item => !item.guia_transfer_view?.id_guia);

  function deleteRow(id) {
    checkeds.splice(
      checkeds.findIndex((x) => x.id == id),
      1
    );
    setCheckeds([...checkeds]);
  }

  async function listKardex(search) {
    setDataLoading(true);
    setValueSearch(search);
    const typeInventory = type === "ETI" ? "Y" : type === "OTI" ? "Y" : "N";

    const params = {
      ...search,
      TypeInventory: typeInventory,
    };
    let response = await wsFindBy(entity, params);
    setDataLoading(false);
    if (response.success){
      setKardexs(response.data);
      setCheckeds([]);  
    }
  }

  function getUrlPDF(idItem) {
    setDataLoading(true);
    let urlPdfHR = wsUrl(`${entity}/${idItem}/report`);
    setURLPDF(urlPdfHR);
    setOpenPDF(true);
    setDataLoading(false);
  }
  async function ModalVerPDF(idGuia) {
    setDataLoading(true);
    try {
      // const dataGuiaID = dataGuia.id[0];
      const response = await wsGetPdfPromise(`logi/guia-transfer/${idGuia}/ver-guia`);
      setURLPDF(response);
      setOpenPDF(true);
    } catch (error) {
      showNotify('Error al generar el PDF', 'error');
      setURLPDF(null);
    } finally {
    }
    setDataLoading(false);
  }

  async function restoreError(item) {
    setDataLoading(true);
    setProcessing(true);
    let res = await wsUpdate(`${entity}/${item.id}/remove-error`);
    setProcessing(false);
    setDataLoading(false);
    if (res.success) {
      listKardex(valueSearch);
    }
    window.alert(res.message);
  }

  function validateTransfersConsistency(transfers, onContinue = false) {
    if (!transfers.length) return false;

    const first = transfers[0];

    const sameFillerWarehouse = transfers.every(t => String(t.filler_warehouse_id) === String(first.filler_warehouse_id));
    const sameFillerZone = transfers.every(t => String(t.filler_zone_id) === String(first.filler_zone_id));
    const sameToZone = transfers.every(t => String(t.to_zone_id) === String(first.to_zone_id));
    const sameToWarehouse = transfers.every(t => String(t.to_warehouse_id) === String(first.to_warehouse_id));

    if (!sameFillerWarehouse || !sameFillerZone || !sameToZone || !sameToWarehouse) {
      showNotify('Las transferencias seleccionadas no pertenecen a la misma zona o almacén.', 'info');
      return false;
    }

    const firstGuiaId = first.guia_transfer_view?.id_guia ?? null;
    const sameGuia = transfers.every(t => (t.guia_transfer_view?.id_guia ?? null) === firstGuiaId);

    if (!sameGuia) {
      showNotify('Las transferencias seleccionadas no pertenecen a la misma guía.', 'info');
      return false;
    }
    if(!!onContinue){
      const fechas = transfers.map(t => moment(t.DocDate));
      const minFecha = moment.min(fechas);
      const maxFecha = moment.max(fechas);
      const diferenciaDias = maxFecha.diff(minFecha, 'days');
  
      if (diferenciaDias > 1) {
        setAlert(
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title={`Las transferencias seleccionadas tienen fechas diferentes (${diferenciaDias} días), ¿Desea continuar?`}
            onConfirm={() => {
              onContinue();
              setAlert(null);
            }}
            onCancel={() => setAlert(null)}
            confirmBtnCssClass={classes.button + ' ' + classes.success}
            cancelBtnCssClass={classes.button + ' ' + classes.danger}
            confirmBtnText="Continuar"
            cancelBtnText="Cancelar"
            showCancel
          />
        );
        return false;
      }
    }
    return true;
  }

  async function removeGuia() {
    const guiaId = checkeds[0]?.guia_transfer_view?.id_guia;
    const transferIds = checkeds.map(item => item.id);
    let response = await wsRemove(`logi/guia-transfer/${guiaId}`, {
      logi_transfer_ids: transferIds,
    });
    if (response.success) {
      showNotify(response.message);
      listKardex(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }
  async function updateGuia(stateG) {
    const guiaId = checkeds[0]?.guia_transfer_view?.id_guia;
    let response = await wsUpdate(`logi/guia/${guiaId}/update-state`, {
      state: stateG,
    });
    if (response.success) {
      showNotify(response.message);
      listKardex(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }
  function confirm(action, state) {
    let titleMessage = "¿Está seguro?";
    if (action === 'remove') {
      titleMessage = "¿Está seguro de remover la guia?";
    } else if (action === 'state') {
      titleMessage = "¿Está seguro de cerrar la guia?";
    } else if (action === 'closeState') {
      titleMessage = "¿Está seguro de finalizar la guia?";
    }
    const hideAlert = () => {
      setAlert(null);
    };
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={titleMessage}
        onConfirm={() => {
          if (action === 'remove') {
            removeGuia();
          } else if (action === 'state') {
            updateGuia(state);
          } else if (action === 'closeState') {
            updateGuia(state);
          }
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  return (
    // <>
    <GridContainer>
      <Toasty action={notify} />
      {alert}
      <ModalFull
        title="Hoja reparto"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>
      <ModalFull
        title="Guia de transferencia"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
          
        </iframe>
      </ModalFull>
      {openModalGuia && (
        <ModalGuia
          open={openModalGuia}
          onClose={() => setOpenModalGuia(false)}
          selectedTransfers={checkeds}
          showNotify={showNotify}
          reload={() => listKardex(valueSearch)}
        />
      )}
      {openModalUpdate && (
        <ModalUpdate
          open={openModalUpdate}
          onClose={() => setOpenModalUpdate(false)}
          showNotify={showNotify}
          selectedTransfers={checkeds}
          reload={() => listKardex(valueSearch)}
        />
      )}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            {(type === 'ET' || type === 'OT' || type === 'TR') ? (
              <AllowedGuard
                permission={permissions.store}
                component={
                  <CardIcon color={props.themeContext.buttonColor}>
                    <Assignment style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <Link to={`nuevo?type=${type}`}>
                  <CardIcon pointer="true" color="success">
                    <Add style={{ color: 'white' }} />
                  </CardIcon>
                </Link>
              </AllowedGuard>
            ) : (
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
            )}
            <h4 className={classes.cardIconTitle}>Listado de {title} {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              dateRange
              getFilter={listKardex}
              state
              nameState="state_migrate"
              zone
              warehouse="T"
              optionValues={['D', 'V', 'X', 'P']}
              nameOptions={['Borrador', 'Validado', 'Procesando', 'Completo']}
            />
            <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
              <Button
                size="sm"
                onClick={() => {
                  if (checkeds.length === 0) {
                    window.alert("Seleccione al menos una transferencia.");
                    return;
                  }
                  const continuar = () => setOpenModalGuia(true);
                  if (validateTransfersConsistency(checkeds, continuar)) {
                    setOpenModalGuia(true);
                  }
                }}
                color={props.themeContext.buttonColorWarning}
                disabled={checkeds.length === 0 || !noneHaveGuia}
              >
                Crear Datos De Guía
              </Button>
            </AllowedGuard>

            {checkeds.length > 0 && checkeds[0]?.guia_transfer_view?.state === 'D' ? (
              <>
                <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
                  <Button
                    size="sm"
                    onClick={() => {
                      if (checkeds.length === 0) {
                        window.alert("Seleccione al menos una transferencia.");
                        return;
                      }
                      if (validateTransfersConsistency(checkeds)) {
                        setOpenModalUpdate(true);
                      }
                    }}
                    color={props.themeContext.buttonColorInfo}
                    disabled={checkeds.length === 0 || !allHaveGuia}
                  >
                    Actualizar datos de la guía
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      if (checkeds.length === 0) {
                        window.alert("Seleccione al menos una transferencia.");
                        return;
                      }
                      if (validateTransfersConsistency(checkeds)) {
                        confirm('state', 'V');
                      }
                    }}
                    color='success'
                    disabled={checkeds.length === 0 || !allHaveGuia}
                  >
                    Cerrar Guía
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      if (checkeds.length === 0) {
                        window.alert("Seleccione al menos una transferencia.");
                        return;
                      }
                      if (validateTransfersConsistency(checkeds)) {
                        confirm('remove');
                      }
                    }}
                    color='danger'
                    disabled={checkeds.length === 0 || !allHaveGuia}
                  >
                    Eliminar datos de la guía Masivamente
                  </Button>
                </AllowedGuard>
              </>
            ) : undefined}
            {checkeds[0]?.guia_transfer_view?.state === 'V' ? (
              <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
                <Button
                  size="sm"
                  onClick={() => {
                    if (checkeds.length === 0) {
                      window.alert("Seleccione al menos una transferencia.");
                      return;
                    }
                    if (validateTransfersConsistency(checkeds)) {
                      confirm('closeState', 'P');
                    }
                  }}
                  color='success'
                  disabled={checkeds.length === 0 || !allHaveGuia}
                >
                  Finalizar Guía
                </Button>
              </AllowedGuard>
            ) : undefined}
            <ReactTable
              excelName={excelName}
              formatDate="DD-MM-YYYY"
              defaultWidth={1800}
              columns={type === 'TR' ? transferColumns : type === 'ET' || type === 'OT' || type === 'TR' ? columns : columnsMovementInventory}
              data={kardexs.map((item, i) => {
                let state;
                let stateColor = '';
                let hasError = false;
                switch (item.state_migrate) {
                  case 'D':
                    stateColor = 'warning';
                    state = 'Borrador';
                    break;
                  case 'V':
                    stateColor = 'primary';
                    state = 'Validado';
                    break;
                  case 'X':
                    stateColor = 'info';
                    state = 'Procesando';
                    break;
                  case 'P':
                    stateColor = 'success';
                    state = 'Completo';
                    break;
                  default:
                    stateColor = 'gray';
                    state = 'Otros';
                    break;
                }
                if (item.state_migrate === 'X' && item.sapCount >= 3) {
                  hasError = true;
                }
                let guide = null;
                if (!!item.GuideSerie) {
                  guide = `${item.GuideSerie}-${item.GuideNumber.padStart(8, '0')}`;
                }
                return {
                  num: (
                    <Box display="flex" alignItems="center">
                      {i + 1}
                      <OpenWorkday
                        item={item}
                        checkeds={checkeds}
                        setCheckeds={setCheckeds}
                        deleteRow={deleteRow}
                        // disabled={processing}
                      />
                      <AllowedGuard permission={permissions.show}>
                        <Button justIcon round simple>
                          <Link to={`${item.id}?type=${type}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>

                      <AllowedGuard permission={permissions.show}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => getUrlPDF(item.id)}
                          disabled={item.DocEntry === null}
                        >
                          <PictureAsPdf />
                        </Button>
                        <Button
                          justIcon
                          round
                          simple
                          color="success"
                          onClick={() => {
                            const guiaId = item.guia_transfer_view?.id_guia;
                            ModalVerPDF(guiaId);
                          }}
                          disabled={!item.guia_transfer_view?.id_guia}
                        >
                          <PictureAsPdf />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={permissions.delete}>
                        <ButtonDelete
                          disabled={['P'].includes(item.state_migrate)}
                          entity={entity}
                          id={item.id}
                          reload={() => listKardex(valueSearch)}
                        />
                      </AllowedGuard>

                      {hasError ? (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <Tooltip title={item.sapError}>
                            <div>
                              <Badge color="danger">Error!</Badge>
                            </div>
                          </Tooltip>
                          <Button
                            size="sm"
                            color="danger"
                            disabled={processing}
                            justIcon
                            simple
                            round
                            onClick={() => restoreError(item)}
                          >
                            <Restore />
                          </Button>
                        </div>
                      ) : (
                        <div>
                          <Badge color={stateColor}>{state}</Badge>
                        </div>
                      )}
                    </Box>
                  ),
                  id: item.id.toString(),
                  TaxDate: item.TaxDate,
                  DocDate: item.DocDate,
                  guideTransfer: item.guia_transfer_view?.id_guia
                    ? item.guia_transfer_view.state === 'P'
                      ? `Finalizado (ID: ${item.guia_transfer_view.id_guia})`
                      : `Generado (ID: ${item.guia_transfer_view.id_guia})`
                    : 'No generado',
                  guide: guide || 'No generado',
                  DetailAmount:
                    item.DetailAmount === null
                      ? '-'
                      : `S/${parseFloat(item.DetailAmount).toFixed(2)}`,
                  providers: item.providers || "-",
                  marks: item.marks || "-",
                  Ref2: item.Ref2,
                  WhsName: item.WhsName,
                  FillerWhsName: item.FillerWhsName,
                  ToWhsName: item.ToWhsName,
                  WhsAcctCode: item.WhsAcctCode,
                  JrnlMemo: item.JrnlMemo,
                  state_migrate: state,
                  user_validated: item.user_validated,
                  created_user_name: item.created_user_name,
                  validated_user_name: item.validated_user_name,
                  approved_user_name: item.approved_user_name,
                  Comments: item.Comments,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
    // </>
  );
});

const OpenWorkday = ({ item, checkeds = [], setCheckeds, deleteRow, disabled }) => {
  return (
    <Checkbox
      edge="start"
      checked={checkeds.some((obj) => obj.id == item.id)}
      onChange={(e) => {
        if (e.target.checked) {
          setCheckeds([...checkeds, item]);
        } else {
          deleteRow(item.id);
        }
      }}
      tabIndex={-1}
      style={{ marginLeft: '0px' }}
      disabled={ disabled === true ? true : item.state_migrate !== 'P' || item.guia_transfer_view?.state === 'P' }
    />
  );
};